import { storage } from 'src/utils/storage';

import type { LoginResponse } from 'src/features/auth/types';

function handleUserResponse(data: LoginResponse) {
    const { user, ...tokens } = data;
    storage.setToken(tokens);
    storage.setLanguage(user.lang);
    return user;
}

export { handleUserResponse };
